<template>
    <BreadCrumb PageTitle="Methode de paiement d'un BESC" />
    <PaiementMethode />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import PaiementMethode from "@/components/BESC/PaiementMethode.vue";
  
    export default defineComponent({
      name: "PaiementMethodePage",
      components: {
        BreadCrumb,
        PaiementMethode,
      },
    });
  </script>